var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { attrs: { slot: "text-content" }, slot: "text-content" },
              [
                _c("pnet-submit-quote-update", {
                  attrs: {
                    quote: _vm.value,
                    vehicle: _vm.vehicle,
                    customer: _vm.customer,
                  },
                  model: {
                    value: _vm.submitQuoteUpdateObject,
                    callback: function ($$v) {
                      _vm.submitQuoteUpdateObject = $$v
                    },
                    expression: "submitQuoteUpdateObject",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    "data-tooltip": "Submit Quote Update",
                    disabled: _vm.isSubmitDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                  ]),
                  _c("span", [_vm._v("Submit")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }